interface CourseLibraryIconProps {
  className?: string;
}

export default function CourseLibraryIcon({ className }: CourseLibraryIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.4"
        d="M8.25 6.75C6.5955 6.75 5.25 8.0955 5.25 9.75C5.25 11.4045 6.5955 12.75 8.25 12.75C9.9045 12.75 11.25 11.4045 11.25 9.75C11.25 8.0955 9.9045 6.75 8.25 6.75ZM7.125 11.901V7.599L10.3523 9.75L7.125 11.901ZM20.25 1.5H3.75C2.0955 1.5 0.75 2.8455 0.75 4.5V15C0.75 16.6545 2.0955 18 3.75 18H20.25C21.9045 18 23.25 16.6545 23.25 15V4.5C23.25 2.8455 21.9045 1.5 20.25 1.5ZM8.25 14.25C5.76825 14.25 3.75 12.2318 3.75 9.75C3.75 7.26825 5.76825 5.25 8.25 5.25C10.7318 5.25 12.75 7.26825 12.75 9.75C12.75 12.2318 10.7318 14.25 8.25 14.25ZM20.25 13.5H14.25V12H20.25V13.5ZM20.25 10.5H14.25V9H20.25V10.5ZM20.25 7.5H14.25V6H20.25V7.5Z"
        fill="currentColor"
      />
      <path
        d="M14.25 21V19.5H9.75V21H6.75V22.5H17.25V21H14.25Z"
        fill="currentColor"
      />
      <path
        d="M8.25 6.75C6.5955 6.75 5.25 8.0955 5.25 9.75C5.25 11.4045 6.5955 12.75 8.25 12.75C9.9045 12.75 11.25 11.4045 11.25 9.75C11.25 8.0955 9.9045 6.75 8.25 6.75ZM7.125 11.901V7.599L10.3523 9.75L7.125 11.901ZM8.25 14.25C5.76825 14.25 3.75 12.2318 3.75 9.75C3.75 7.26825 5.76825 5.25 8.25 5.25C10.7318 5.25 12.75 7.26825 12.75 9.75C12.75 12.2318 10.7318 14.25 8.25 14.25ZM20.25 13.5H14.25V12H20.25V13.5ZM20.25 10.5H14.25V9H20.25V10.5ZM20.25 7.5H14.25V6H20.25V7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
